/* jshint node: true */
"use strict";
// var React = require('react');
// var ReactDOM = require('react-dom');

// var DepTree = require('./components/DepTree.jsx');

// global.DepTree = DepTree;

require('./js/setup.js');